var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(_vm.isLogin)?_c('LoginPanel',{on:{"showRegister":_vm.hideLogin,"loginSuccess":_vm.loginSuccess}}):_c('RegisterPanel',{on:{"switchLogin":_vm.showLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }